<template>
	 <v-container>
		 <v-dialog title="拒绝请假" v-model="hideShow" width="500px" persistent>
			<v-card>
				<v-card-title>
					<span>拒绝请假</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense v-if="absenceViewModel">
						<v-col cols="12">
							<v-text-field label="课程" v-model="absenceViewModel.courseName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="班级" v-model="absenceViewModel.className" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="学员" v-model="absenceViewModel.studentName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="课次" :value="absenceViewModel.classDate + ' ' + absenceViewModel.timeFrom +'-'+absenceViewModel.timeTo" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="拒绝原因" v-model="update.refuseReason" dense outlined></v-text-field>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" :disabled="update.submitting" :loading="update.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"refuse-absence",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			absenceModel:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.absenceViewModel = this.absenceModel;
				}
			}
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				absenceViewModel:null,
				update:{
					submitting:false,
					refuseReason:"",
				}
			}
		},
		mounted() {
			console.log("refuse absence mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			submitUpdate(){
				if(!this.update.refuseReason){
					this.$noty.error("请输入拒绝原因");
					return
				}
				this.update.submitting = true;
				
				let postData = {
					absenceId:this.absenceModel.id,
					refuseReason:this.update.refuseReason,
				}
				// api
				const that = this;
				const shopId = this.shopId || utils.getCurrentShopId();
				let url = `/edu/absence/refuse`;
				if (shopId) {
					url += `?shopId=${shopId}`;
				}
					
				this.axios.post(url, postData).catch(() => {
					that.update.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							
							that.update.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.update.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
				
			},
			
			
			
		}
	}
	
</script>

<style>
</style>
